export const ACTION_ICON_CELL = 'Actions';
